import BrandsSubscriptionsFull from './components/BrandsSubscriptionsFull';
import { isFeatureEnabled } from 'owa-feature-flags';
import { Option } from 'owa-options-core';
import * as React from 'react';

const BrandsSubscriptionsOption: Option = {
    key: 'brandsSubscriptionsOption',
    titleStringKey: 'optionTitle_subscriptionActions',
    searchTermsStringKey: 'optionTitle_subscriptionActions',
    hideTitleInFullOptions: true,
    fullOptionFormSettings: {
        render: () => <BrandsSubscriptionsFull />,
        isDirty: () => false,
        onSave: () => {
            return Promise.resolve();
        },
        onDiscard: () => {
            return;
        },
        hideSaveDiscard: () => {
            return true;
        },
    },
    isHidden: () => !isFeatureEnabled('doc-brandsSubscriptions'),
};

export default BrandsSubscriptionsOption;
